window.evdnceApplySwatchVisibility = function(g) {
  var gender = g || sessionStorage.getItem('evdnce_gender');

  // PDP colour swatches (evp-swatch)
  document.querySelectorAll('.evp-swatch').forEach(function(swatch) {
    if (gender === 'women') {
      if (swatch.getAttribute('data-has-women') === 'true') {
        swatch.classList.remove('evdnce-no-women');
      } else {
        swatch.classList.add('evdnce-no-women');
      }
    } else {
      swatch.classList.remove('evdnce-no-women');
    }
  });

  // PLP + PDP card swatches (evdnce-card-swatch)
  document.querySelectorAll('.evdnce-card-swatch').forEach(function(swatch) {
    if (gender === 'women') {
      if (swatch.hasAttribute('data-image-women')) {
        swatch.classList.remove('evdnce-no-women');
      } else {
        swatch.classList.add('evdnce-no-women');
      }
    } else {
      swatch.classList.remove('evdnce-no-women');
    }
  });

  // Hide men-only/women-only cards (View the Range, Style With etc)
  document.querySelectorAll('product-card[data-product-gender]').forEach(function(card) {
    var pg = card.getAttribute('data-product-gender');
    var hide = (gender === 'women' && pg === 'men') || (gender === 'men' && pg === 'women');

    // Hide the card itself
    card.style.display = hide ? 'none' : '';

    // Walk up and hide any swiper-slide parent (both desktop + mobile swiper)
    var el = card.parentElement;
    while (el) {
      if (el.classList && el.classList.contains('swiper-slide')) {
        el.style.display = hide ? 'none' : '';
        break;
      }
      el = el.parentElement;
    }
  });

  // Sticky ATC image - swap to women's image if available
  var stickyImg = document.querySelector('.product__sticky-cart--info .media img');
  if (stickyImg && gender === 'women') {
    var womenSlide = document.querySelector('.swiper--product-gallery .swiper-slide:not(.evdnce-gender-hidden) img');
    if (womenSlide && womenSlide.src) {
      stickyImg.src = womenSlide.src;
      stickyImg.srcset = '';
    }
  }

  // Update all swipers after hiding slides
  setTimeout(function() {
    document.querySelectorAll('.swiper').forEach(function(el) {
      if (el.swiper) {
        el.swiper.update();
      }
    });
  }, 50);
};

// Run on load
(function() {
  function init() {
    if (typeof window.evdnceApplySwatchVisibility === 'function') {
      window.evdnceApplySwatchVisibility();
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 500);
  setTimeout(init, 1500);
})();
